import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useServices } from 'index';
import { AdminModule } from 'types/admin/modulesV2';

type Callbacks = {
  onMutate?: () => void;
  onSuccess?: (id: string) => Promise<void> | void;
  onSettled?: () => void;
};

export const useCreateModuleV2 = (callbacks?: Callbacks) => {
  const service = useServices().moduleListV2Service;
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (module: AdminModule) => service.createModule(module),
    onMutate: callbacks?.onMutate,
    onSuccess: async (id: string) => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['adminModuleListV2'] }),
        queryClient.invalidateQueries({ queryKey: ['learningHubModuleList'] }),
      ]);
      await callbacks?.onSuccess?.(id);
    },
    onSettled: callbacks?.onSettled,
  });
};
